import { render, staticRenderFns } from "./DataGridClick.vue?vue&type=template&id=c8637198&scoped=true&functional=true&"
import script from "./DataGridClick.vue?vue&type=script&lang=ts&"
export * from "./DataGridClick.vue?vue&type=script&lang=ts&"
import style0 from "./DataGridClick.vue?vue&type=style&index=0&id=c8637198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "c8637198",
  null
  
)

export default component.exports